module.exports = __webpack_public_path__ + "img/turbina.8ee5ad6e.gif";